module.exports = __webpack_public_path__ + "static/img/ent-detail-9.2ef62aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-9.jpg
// module id = n8WM
// module chunks = 52